/** Read intrinsic duration and (for video) natural dimensions of a media
 *  blob URL via a detached HTMLMediaElement. Resolves zeros on failure —
 *  callers fall back to defaults. DOM-bound; covered by E2E, not Vitest. */
export function probeMediaMetadata(
  blobUrl: string,
  kind: 'video' | 'audio',
): Promise<{ duration: number; width: number; height: number }> {
  return new Promise((resolve) => {
    const el = document.createElement(kind);
    el.preload = 'metadata';
    el.onloadedmetadata = () => {
      const d = el.duration;
      const width = el instanceof HTMLVideoElement ? el.videoWidth : 0;
      const height = el instanceof HTMLVideoElement ? el.videoHeight : 0;
      el.removeAttribute('src');
      resolve({
        duration: Number.isFinite(d) && d > 0 ? d : 0,
        width,
        height,
      });
    };
    el.onerror = () => resolve({ duration: 0, width: 0, height: 0 });
    el.src = blobUrl;
  });
}
